/** Préférence de vue planning (classic / modern / capacity). */

export type PlanningViewKind = 'classic' | 'modern' | 'capacity';

/** Vues proposées dans le sélecteur (classic conservé pour deep links uniquement). */
export type SelectablePlanningViewKind = 'modern' | 'capacity';

const STORAGE_KEY = 'planningViewPreference';

export function readPlanningViewKind(): PlanningViewKind {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'classic') {
    writePlanningViewKind('modern');
    return 'modern';
  }
  if (saved === 'modern' || saved === 'capacity') {
    return saved;
  }
  return 'capacity';
}

/** Valeur affichée dans le sélecteur (classic masqué → modern). */
export function toSelectorPlanningViewKind(
  kind: PlanningViewKind
): SelectablePlanningViewKind {
  return kind === 'classic' ? 'modern' : kind;
}

export function writePlanningViewKind(kind: PlanningViewKind): void {
  localStorage.setItem(STORAGE_KEY, kind);
}

export function isModernLikeView(kind: PlanningViewKind): boolean {
  return kind === 'modern' || kind === 'capacity';
}
